export class 期限切れ破棄破損検索条件型 {
  検索文字列: string;

  商品名選択: 選択区分型;
  商品名カナ選択: 選択区分型;
  規格容量選択: 選択区分型;
  メーカー名選択: 選択区分型;
  メーカー名カナ選択: 選択区分型;

  検索開始処理日: Date | null;
  検索終了処理日: Date | null;
  検索開始登録日: Date | null;
  検索終了登録日: Date | null;

  入力区分: string | null;
  商品区分: string | null;
  使用区分: string | null;

  constructor(検索文字列: string,
              商品名選択: 選択区分型,
              商品名カナ選択: 選択区分型,
              規格容量選択: 選択区分型,
              メーカー名選択: 選択区分型,
              メーカー名カナ選択: 選択区分型,
              検索開始処理日: Date | null,
              検索終了処理日: Date | null,
              検索開始登録日: Date | null,
              検索終了登録日: Date | null,
              入力区分: string | null,
              商品区分: string | null,
              使用区分: string | null) {
    this.検索文字列 = 検索文字列;
    this.商品名選択 = 商品名選択;
    this.商品名カナ選択 = 商品名カナ選択;
    this.規格容量選択 = 規格容量選択;
    this.メーカー名選択 = メーカー名選択;
    this.メーカー名カナ選択 = メーカー名カナ選択;
    this.検索開始処理日 = 検索開始処理日;
    this.検索終了処理日 = 検索終了処理日;
    this.検索開始登録日 = 検索開始登録日;
    this.検索終了登録日 = 検索終了登録日;
    this.入力区分 = 入力区分;
    this.商品区分 = 商品区分;
    this.使用区分 = 使用区分;
  }
}

export function 期限切れ破棄破損検索条件初期値() {
  return new 期限切れ破棄破損検索条件型('', 選択区分型.選択, 選択区分型.選択, 選択区分型.選択,
                                   選択区分型.選択, 選択区分型.選択, null, null, null,
                                   null, null, null, null);
}

export enum 選択区分型 {
  選択 = '選択',
  非選択 = '非選択',
}
